import { UrlRegex } from 'lib/string'
import { Post } from 'lib/_types'
import { sortBy } from 'lodash'

export type TextDetailTypes = 'user' | 'link' | 'hash' | 'break' | 'space'
export type TextDetail = {
  text?: string
  target?: string | number
  type?: TextDetailTypes
}

export const extractPost = (post: Post): TextDetail[] => {
  const extractedUser = extractUser(post)
  const result: TextDetail[] = []

  extractedUser.forEach((item) => {
    if (item.type === 'user') {
      result.push(item)
      return
    }

    // Split text into each word separated by space
    const texts = item.text
      .split(/\r\n|\n\r|\n|\r/)
      .map((row) => row.split(/\s+/))
      .filter((row) => row.length)

    texts.forEach((row, i) => {
      if (i > 0) result.push({ type: 'break' })

      row.forEach((word, j) => {
        if (j > 0) result.push({ type: 'space' })
        if (!word) return

        result.push(...extractHashLink(word))
      })
    })
  })

  return result
}

const extractUser = (post: Post): TextDetail[] => {
  // Extract user mentions
  const textList: TextDetail[] = []

  // sort by offset
  const mentionList = sortBy(post.message_tags, (tag) => tag.offset)

  let text = post.text.replace(/\r\n|\n\r|\n|\r/g, '\n')
  let last = 0
  mentionList.forEach((mention) => {
    if (last !== mention.offset) {
      textList.push({ text: text.substring(last, mention.offset) })
    }

    textList.push({
      text: text.substring(mention.offset, mention.offset + mention.length),
      target: mention.user_id,
      type: 'user',
    })

    last = mention.offset + mention.length
  })

  if (last !== text.length) {
    textList.push({ text: text.substring(last) })
  }

  return textList
}

const extractHashLink = (word: string): TextDetail[] => {
  // Extract hash
  if (word.startsWith('#'))
    return [
      {
        text: word,
        target: word.substring(1),
        type: 'hash',
      },
    ]

  // Extract link
  const matched = word.match(UrlRegex)
  if (matched) {
    const result: TextDetail[] = []

    const i = word.indexOf(matched[0])
    if (i > 0) {
      result.push({ text: word.substring(0, i) })
    }

    result.push({
      text: matched[0],
      type: 'link',
    })

    // Check for link again if still have word after link
    const restWord = word.substring(i + matched[0].length)
    if (restWord.length) {
      result.push(...extractHashLink(restWord))
    }

    return result
  }

  // Normal text
  return [{ text: word }]
}
